var map = {
	"./404.jsx": 438,
	"./_template.jsx": 383,
	"./about/index.jsx": 454,
	"./confidentiality/index.jsx": 458,
	"./contact/index.jsx": 461,
	"./index.jsx": 464,
	"./work/animalz/index.jsx": 466,
	"./work/caoua/index.jsx": 600,
	"./work/incruizer/index.jsx": 726,
	"./work/index.jsx": 732,
	"./work/lebonchoix/index.jsx": 738,
	"./work/sociallyfox/index.jsx": 744,
	"./work/swipolitique/index.jsx": 754
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 437;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|ts|tsx|jsx|js|md|rmd|mkdn?|mdwn|mdown|markdown|litcoffee|ipynb|html|json|yaml|toml)$
// module id = 437
// module chunks = 0